<template>
  <div id="jumbotron">
    <div class="overlay"></div> <!-- Blue blur overlay -->
    <div class="container content">
      <p class="title">{{ $t('whyUsPage.title') }}</p>
    </div>
  </div>
  <WhyUs />
</template>

<script>
  import WhyUs from '../components/WhyUs.vue';
  export default {
    components: { WhyUs }
  };
</script>

<style scoped>
  #jumbotron {
    position: relative;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/banner-buiding.webp");
    background-size: cover;
    background-position: center;
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Blue blurry overlay */
  #jumbotron .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(19, 5, 115, 0.75); /* Blue tint */
  }

  #jumbotron .content {
    position: relative;
    z-index: 2;
  }

  #jumbotron .title {
    color: white;
    font-size: 5em;
    font-weight: bold;
  }
</style>